export const BASE_URL = "https://api-mec.radiant-ia.tech";
// process.env.REACT_APP_API_URL != ""
//   ? process.env.REACT_APP_API_URL
//   :
